// 商行详情 — 针式打印：配货单模板编辑
import React, { PureComponent } from 'react';
import qs from 'qs';
import { message, Space } from 'antd-v5';
import { Button, Checkbox, Radio } from '@/components';
import PageHeaderLayout from '../../../../component/page-header-layout/index';
import { requestNeedleMemoTemplateEdit } from '../../../../state/request/tag';
import '../detail.less';
import './stallDotMatrixPrintTemplate.less';
import {
  PRINT_STYLE_OPTIONS,
  MEMO_FIELD_CHECKBOX_OPTIONS,
  MEMO_FIELD_MAX_COUNT,
} from './stallDotMatrixPrintShared';
import {
  initDistributionFormState,
  buildNeedleMemoTemplateSaveParams,
} from './stallDotMatrixMemoTemplatePayload';

class StallDotMatrixDistributionEdit extends PureComponent {
  constructor(props) {
    super(props);
    const { templateBO } = props.location.state || {};
    this.state = {
      ...initDistributionFormState(templateBO),
      saving: false,
    };
  }

  /** 进入本页时滚到顶部（详情页较长时从中间位置跳转过来会保留滚动条） */
  scrollPageToTop = () => {
    window.scrollTo(0, 0);
    if (typeof document !== 'undefined') {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      const layoutContent = document.querySelector('.ant-layout-content');
      if (layoutContent) {
        layoutContent.scrollTop = 0;
      }
    }
  };

  componentDidMount() {
    this.scrollPageToTop();
    const stallId = this.props.location.state && this.props.location.state.stallId;
    if (!stallId) {
      message.warning('缺少商行信息');
      this.props.history.replace('/booth/stallManager');
    }
  }

  /** 返回商行详情并停留在针式打印模板 Tab */
  goBackToStallDetail = () => {
    const { history, location } = this.props;
    const { stallId, tab = '18' } = location.state || {};
    if (!stallId) {
      history.push('/booth/stallManager');
      return;
    }
    history.push({
      pathname: '/booth/stallManager/stallManagementDetail',
      state: { stallId },
      search: qs.stringify({ tab: String(tab) }, { addQueryPrefix: true }),
    });
  };

  handleCancel = () => {
    this.goBackToStallDetail();
  };

  handleFieldKeysChange = (next) => {
    if (next.length > MEMO_FIELD_MAX_COUNT) {
      message.warning(`最多同时选择${MEMO_FIELD_MAX_COUNT}个字段`);
      return;
    }
    this.setState({ fieldKeys: next });
  };

  handleSave = async () => {
    const { stallId } = this.props.location.state || {};
    const { printStyle, fieldKeys, saving } = this.state;
    if (!stallId) {
      message.error('缺少商行信息');
      return;
    }
    if (saving) return;

    this.setState({ saving: true });
    try {
      const params = buildNeedleMemoTemplateSaveParams({ printStyle, fieldKeys }, stallId);
      const res = await requestNeedleMemoTemplateEdit(params);
      if (res?.code === 200) {
        message.success('保存成功');
        this.goBackToStallDetail();
      }
    } catch {
      message.error('保存失败');
    } finally {
      this.setState({ saving: false });
    }
  };

  render() {
    const { printStyle, fieldKeys, saving } = this.state;

    return (
      <PageHeaderLayout>
        <div className='StallManagementDetail'>
          <div className='stallDotMatrixPrintTemplate'>
            <div className='distributionEditPanel'>
              <div className='section'>
                <div className='sectionHeader' style={{ paddingTop: 16 }}>
                  <div className='sectionTitle'>基本设置</div>
                </div>

                <div className='distributionEditForm'>
                  <div className='formRow'>
                    <div className='formLabel'>打印样式</div>
                    <div className='formControl'>
                      <Radio.Group
                        value={printStyle}
                        onChange={(e) => this.setState({ printStyle: e.target.value })}
                      >
                        <Space direction='horizontal' size={12}>
                          {PRINT_STYLE_OPTIONS.map((opt) => (
                            <Radio key={opt.value} value={opt.value}>
                              {opt.label}
                            </Radio>
                          ))}
                        </Space>
                      </Radio.Group>
                    </div>
                  </div>

                  <div className='formRow'>
                    <div className='formLabel'>字段设置</div>
                    <div className='formControl'>
                      <Checkbox.Group
                        options={MEMO_FIELD_CHECKBOX_OPTIONS}
                        value={fieldKeys}
                        onChange={this.handleFieldKeysChange}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className='distributionEditFooter'>
                <Button onClick={this.handleCancel}>取消</Button>
                <Button type='primary' loading={saving} onClick={this.handleSave}>
                  保存
                </Button>
              </div>
            </div>
          </div>
        </div>
      </PageHeaderLayout>
    );
  }
}

export default StallDotMatrixDistributionEdit;
